"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/token/index.ts
var token_exports = {};
__export(token_exports, {
  PROFILE_ACCESS_TOKEN_KEY: () => PROFILE_ACCESS_TOKEN_KEY,
  USER_ACCESS_TOKEN_KEY: () => USER_ACCESS_TOKEN_KEY,
  clearAllTokens: () => clearAllTokens,
  getProfileToken: () => getProfileToken,
  setProfileToken: () => setProfileToken,
  setUserToken: () => setUserToken
});
module.exports = __toCommonJS(token_exports);

// src/token/constants.ts
var USER_ACCESS_TOKEN_KEY = "htcUserAccessToken";
var PROFILE_ACCESS_TOKEN_KEY = "htcProfileAccessToken";

// src/token/utils.ts
var import_env = __toESM(require("@repo/env"));
var import_js_cookie = __toESM(require("js-cookie"));
var withSessionStorage = (callback) => {
  const hasSessionStorage = typeof sessionStorage !== "undefined";
  if (hasSessionStorage) {
    return callback();
  }
};
var cookieParams = {
  expires: 30,
  path: "/",
  domain: import_env.default.cookieDomain,
  sameSite: "lax",
  secure: import_env.default.nodeEnv === "production"
};
var setProfileToken = (accessToken) => {
  if (!accessToken) {
    withSessionStorage(
      () => sessionStorage.removeItem(PROFILE_ACCESS_TOKEN_KEY)
    );
    import_js_cookie.default.remove(PROFILE_ACCESS_TOKEN_KEY, cookieParams);
  } else {
    withSessionStorage(
      () => sessionStorage.setItem(PROFILE_ACCESS_TOKEN_KEY, accessToken)
    );
    import_js_cookie.default.set(PROFILE_ACCESS_TOKEN_KEY, accessToken, cookieParams);
  }
};
var persistProfileToken = () => {
  const carryOver = import_js_cookie.default.get(PROFILE_ACCESS_TOKEN_KEY);
  if (carryOver) {
    withSessionStorage(() => {
      if (!sessionStorage.getItem(PROFILE_ACCESS_TOKEN_KEY)) {
        sessionStorage.setItem(PROFILE_ACCESS_TOKEN_KEY, carryOver);
      }
    });
  }
};
var getProfileToken = () => {
  persistProfileToken();
  return withSessionStorage(
    () => sessionStorage.getItem(PROFILE_ACCESS_TOKEN_KEY)
  ) || import_js_cookie.default.get(PROFILE_ACCESS_TOKEN_KEY);
};
var setUserToken = (accessToken) => {
  if (!accessToken) {
    import_js_cookie.default.remove(USER_ACCESS_TOKEN_KEY, cookieParams);
  } else {
    import_js_cookie.default.set(USER_ACCESS_TOKEN_KEY, accessToken, cookieParams);
  }
};
var clearAllTokens = () => {
  withSessionStorage(() => sessionStorage.removeItem(PROFILE_ACCESS_TOKEN_KEY));
  import_js_cookie.default.remove(PROFILE_ACCESS_TOKEN_KEY, cookieParams);
  import_js_cookie.default.remove(USER_ACCESS_TOKEN_KEY, cookieParams);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  PROFILE_ACCESS_TOKEN_KEY,
  USER_ACCESS_TOKEN_KEY,
  clearAllTokens,
  getProfileToken,
  setProfileToken,
  setUserToken
});
